'use client';

import React, { useEffect, useRef } from 'react';

const philosophyPoints = [
{
  declaration: 'Feel in the moment. Not outside it.',
  body: "The best car event shots don't always come from a tripod at the edge of the lot. They come from moving through the crowd, reading the scene, having the eye for those golden moments. I shoot from inside the moment... Crafting the perfect moment."
},
{
  declaration: 'Photography is the craft. The Edit is the magic.',
  body: 'I don\'t direct. I anticipate. The raw energy of a car meet — the smoke, the noise, the culture — that\'s the subject. My job is to be invisible enough that people forget the camera exists, then precise enough to capture the frame that tells the whole story. The edit is where the magic happens, Really bringing that moment to life.'
}];


export default function PhilosophySection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal-hidden');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.remove('reveal-hidden');
                el.classList.add('reveal-visible');
              }, i * 130);
            });
          }
        });
      },
      { threshold: 0.12 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section id="approach" ref={sectionRef} className="py-20 sm:py-28 md:py-36 border-t border-parchment/8">
      <div className="max-w-8xl mx-auto px-4 sm:px-8 md:px-14">

        {/* Section label */}
        <div className="flex items-center gap-4 sm:gap-6 mb-12 sm:mb-16 md:mb-20 reveal-hidden">
          <span className="text-gold text-[0.62rem] tracking-[0.28em] uppercase font-medium whitespace-nowrap">01 — MY APPROACH

          </span>
          <div className="flex-1 h-px bg-parchment/8" />
        </div>

        {/* Alternating asymmetric rows */}
        {philosophyPoints?.map((point, idx) =>
        <div
          key={idx}
          className="grid grid-cols-1 md:grid-cols-asymmetric gap-0">

            {/* Wide column (60) — body text */}
            <div
            className={`py-10 sm:py-14 md:py-20 pr-0 md:pr-20 border-b border-parchment/8 ${
            idx % 2 === 1 ? 'md:order-2' : ''} reveal-hidden`
            }>

              <p className="text-parchment/55 text-sm sm:text-base md:text-lg font-light leading-[1.8] tracking-wide">
                {point?.body}
              </p>
            </div>

            {/* Narrow column (40) — declaration */}
            <div
            className={`py-8 sm:py-12 md:py-20 md:pl-16 border-b border-parchment/8 flex flex-col justify-center ${
            idx % 2 === 1 ? 'md:order-1 md:pl-0 md:pr-16' : ''} reveal-hidden reveal-delay-1`
            }>

              <blockquote className="pull-quote">
                <p className="font-serif text-parchment text-display-md italic font-light leading-[1.15]">
                  {point?.declaration}
                </p>
              </blockquote>
            </div>
          </div>
        )}

        {/* Bottom statement */}
        <div className="mt-14 sm:mt-20 pt-14 sm:pt-20 border-t border-parchment/8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 sm:gap-8 reveal-hidden">
          <div>
            <p className="text-parchment text-sm font-light tracking-wide mb-2">
              Available for car events, shows, rallies, and social shoots.
            </p>
            <p className="text-parchment/35 text-xs tracking-wide font-light">Based in Washington State · Available to travel.

            </p>
          </div>
          <a href="https://ig.me/m/knxckout.media" target="_blank" rel="noopener noreferrer" className="ghost-btn whitespace-nowrap w-full sm:w-auto text-center">
            <span>Book a Shoot</span>
          </a>
        </div>

      </div>
    </section>);

}